<template>
  <two-column-layout>
    <card-container>

      <text-input-fragment
        :label="messages['dealer_code_label']"
        :placeholder="messages['dealer_code_placeholder']"
        v-model="form.data.dealerCode"
        :is-invalid="isFieldInvalid($v.form.data.dealerCode)"
      >
        (Bij 3 letters wordt er een error getoond)
        <template #result>
          <div :class="$style.error" v-if="$v.form.data.dealerCode.$error">{{ messages["dealer_code_label"] }}
            <span v-if="!$v.form.data.dealerCode.required">{{ messages["required"] }}</span>
          </div>
        </template>
      </text-input-fragment>

      <fragment-separator></fragment-separator>

      <text-input-fragment
        :label="messages['external_identifier_label']"
        :placeholder="messages['external_identifier_placeholder']"
        v-model="form.data.externalIdentifier"
      ></text-input-fragment>

      <text-input-fragment
        :label="messages['license_plate_label']"
        :placeholder="messages['license_plate_placeholder']"
        v-model="form.data.licensePlate"
        :is-invalid="isFieldInvalid($v.form.data.licensePlate)"
      >
        <template #result>
          <div :class="$style.error" v-if="$v.form.data.licensePlate.$error">
            {{ messages["license_plate_label"] }}
            <span v-if="!$v.form.data.licensePlate.maxLength">{{ messages["maxLength"].replace("%s", "8") }}</span>
          </div>
        </template>
      </text-input-fragment>
      <div v-if="!form.data.licensePlate">
        <text-input-fragment
          :label="messages['vehicle_make_label']"
          :placeholder="messages['vehicle_make_placeholder']"
          v-model="form.data.make"
          :is-invalid="isFieldInvalid($v.form.data.make)"
        >
          <template #result>
            <div :class="$style.error" v-if="$v.form.data.make.$error">{{ messages["vehicle_make_label"] }}
              <span v-if="!$v.form.data.model.required">{{ messages["required"] }}</span>
            </div>
          </template>
        </text-input-fragment>

        <text-input-fragment
          :label="messages['vehicle_model_label']"
          :placeholder="messages['vehicle_model_placeholder']"
          v-model="form.data.model"
          :is-invalid="isFieldInvalid($v.form.data.model)"
        >
          <template #result>
            <div :class="$style.error" v-if="$v.form.data.model.$error">{{ messages["vehicle_model_label"] }}
              <span v-if="!$v.form.data.model.required">{{ messages["required"] }}</span>
            </div>
          </template>
        </text-input-fragment>
        <text-input-fragment
          :label="messages['vehicle_build_month_label']"
          :placeholder="messages['vehicle_build_month_placeholder']"
          v-model="form.data.buildMonth"
          :is-invalid="isFieldInvalid($v.form.data.buildMonth)"
        >
          <template #result>
            <div :class="$style.error" v-if="$v.form.data.buildMonth.$error">
              {{ messages["vehicle_build_month_label"] }}
              <span v-if="!$v.form.data.buildMonth.required">{{ messages["required"] }}</span>
              <span v-if="!$v.form.data.buildMonth.numeric">{{ messages["numeric"] }}</span>
            </div>
          </template>
        </text-input-fragment>
        <text-input-fragment
          :label="messages['vehicle_build_year_label']"
          :placeholder="messages['vehicle_build_year_placeholder']"
          v-model="form.data.buildYear"
          :is-invalid="isFieldInvalid($v.form.data.buildYear)"
        >
          <template #result>
            <div :class="$style.error" v-if="$v.form.data.buildYear.$error">
              {{ messages["vehicle_build_year_label"] }}
              <span v-if="!$v.form.data.buildYear.required">{{ messages["required"] }}</span>
              <span v-if="!$v.form.data.buildYear.numeric">{{ messages["numeric"] }}</span>
            </div>
          </template>
        </text-input-fragment>

        <radio-group-fragment
          :label="messages['vehicle_type_label']"
          group-name="group vehicle type"
          :options="radioGroupVehicleTypeOptions"
          v-model="form.data.vehicleType"
        >
          <template #result>
            <div :class="$style.error" v-if="$v.form.data.vehicleType.$error">{{ messages["vehicle_type_label"] }}
              <span v-if="!$v.form.data.vehicleType.required">{{ messages["required"] }}</span>
            </div>
          </template>

        </radio-group-fragment>
      </div>
      <text-input-fragment
        :label="messages['vehicle_mileage_label']"
        :placeholder="messages['vehicle_mileage_placeholder']"
        v-model="form.data.mileage"
        :is-invalid="isFieldInvalid($v.form.data.mileage)"
      >
        <template #result>
          <div :class="$style.error" v-if="$v.form.data.mileage.$error">{{ messages["vehicle_mileage_label"] }}
            <span v-if="!$v.form.data.mileage.required">{{ messages["required"] }}</span>
            <span v-if="!$v.form.data.mileage.numeric">{{ messages["numeric"] }}</span>
          </div>
        </template>
      </text-input-fragment>
      <fragment-separator></fragment-separator>

      <radio-group-fragment
        :label="messages['applicant_type_label']"
        group-name="group applicant type"
        :options="radioGroupApplicantTypeOptions"
        v-model="form.data.applicantType"
      >
        <template #result>
          <div :class="$style.error" v-if="$v.form.data.applicantType.$error">{{ messages["applicant_type_label"] }}
            <span v-if="!$v.form.data.applicantType.required">{{ messages["required"] }}</span>
          </div>
        </template>

      </radio-group-fragment>

      <text-input-fragment
        :label="messages['price_label']"
        :placeholder="messages['price_placeholder']"
        v-model="form.data.price"
        size="medium"
        :is-invalid="isFieldInvalid($v.form.data.price)"
      >
        <template #result>
          <div :class="$style.error" v-if="$v.form.data.price.$error">{{ messages["price_label"] }}
            <span v-if="!$v.form.data.price.required">{{ messages["required"] }}</span>
            <span v-if="!$v.form.data.price.numeric">{{ messages["numeric"] }}</span>
          </div>
        </template>
      </text-input-fragment>

      <text-input-fragment
        :label="messages['credit_amount_label']"
        :placeholder="messages['credit_amount_placeholder']"
        v-model="form.data.creditAmount"
        :is-invalid="isFieldInvalid($v.form.data.creditAmount)"
      >
        <template #result>
          <div :class="$style.error" v-if="$v.form.data.creditAmount.$error">{{ messages["credit_amount_label"] }}
            <span v-if="!$v.form.data.creditAmount.required">{{ messages["required"] }}</span>
            <span v-if="!$v.form.data.creditAmount.numeric">{{ messages["numeric"] }}</span>
          </div>
        </template>
      </text-input-fragment>

      <text-input-fragment
        :label="messages['final_term_amount_label']"
        :placeholder="messages['final_term_amount_placeholder']"
        v-model="form.data.finalTermAmount"
        :is-invalid="isFieldInvalid($v.form.data.finalTermAmount)"
      >
        <template #result>
          <div :class="$style.error" v-if="$v.form.data.finalTermAmount.$error">
            {{ messages["final_term_amount_label"] }}
            <span v-if="!$v.form.data.finalTermAmount.required">{{ messages["required"] }}</span>
            <span v-if="!$v.form.data.finalTermAmount.numeric">{{ messages["numeric"] }}</span>
          </div>
        </template>
      </text-input-fragment>

      <radio-group-fragment
        :label="messages['duration_label']"
        group-name="group duration"
        :options="radioGroupDurationTypeOptions"
        v-model="form.data.durationInMonths"
      >
      </radio-group-fragment>

      <radio-group-fragment
        :label="messages['vat_deductible_label']"
        group-name="group vat deductible"
        :options="radioGroupOptionalBooleanOptions"
        v-model="form.data.vatDeductible"
      >
      </radio-group-fragment>

      <radio-group-fragment
        :label="messages['vat_included_label']"
        group-name="group vat included"
        :options="radioGroupOptionalBooleanOptions"
        v-model="form.data.vatIncluded"
      >
      </radio-group-fragment>

      <div :class="$style.error" v-if="form.error">
        <ul>
          <li v-for="error in form.errors" :key="error.code">
            {{ error.code }}: {{ error.message }}
          </li>
        </ul>
      </div>

      <div :class="$style.spinnerWrapper" v-if="loading">
        <span :class="$style.spinner"></span>
      </div>

      <button-group direction="right" top-spacing="l">
        <button-fragment icon-before="cross" tabindex="-1"
                         @click="reset()">{{ messages["button_reset"] }}
        </button-fragment>
        <button-fragment @click="submit()">{{ messages["button_submit"] }}</button-fragment>
      </button-group>


    </card-container>
    <template #right>
      <div id="result-panel"></div>
      <card-container v-if="showCalculationResult">
        <receipt-group-fragment :label="messages['results_title']">
          <receipt-item-fragment :label="messages['external_identifier_label']">
            {{ formatAmount(calculationResult.externalIdentifier) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['price_label']">
            {{ formatAmount(calculationResult.price) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['remaining_bpm_label']">
            {{ formatAmount(calculationResult.remainingBpm) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['vat_amount_label']">
            {{ formatAmount(calculationResult.vatAmount) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['monthly_amount_label']">
            {{ formatAmount(calculationResult.monthlyAmount) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['total_credit_cost_label']">
            {{ formatAmount(calculationResult.totalCreditCost) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['months_duration_in_months_sequence_label']">
            {{ availableDurations }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['credit_amount_lowerboundary_label']">
            {{ formatAmount(calculationResult.creditAmountLowerBoundary) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['deposit_upper_boundary_label']">
            {{ formatAmount(calculationResult.depositUpperBoundary) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['final_term_amount_upperboundary_label']">
            {{ formatAmount(calculationResult.finalTermAmountUpperBoundary) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['interest_effective_label']">
            {{ formatPercentage(calculationResult.interestEffective) }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['finance_company_name_label']">
            {{ calculationResult.financeCompanyName }}
          </receipt-item-fragment>
          <receipt-item-fragment :label="messages['finance_product_name_label']">
            {{ calculationResult.financeProductName }}
          </receipt-item-fragment>
        </receipt-group-fragment>
      </card-container>
    </template>
  </two-column-layout>
</template>

<script>


import { calculate } from "./api/omf-calculate-api";

import {
  ButtonFragment,
  ButtonGroup,
  CardContainer,
  FragmentSeparator,
  RadioGroupFragment,
  ReceiptGroupFragment,
  ReceiptItemFragment,
  TextInputFragment,
  TwoColumnLayout,
} from "@bvm/forms";

const { validationMixin } = require("vuelidate");
const { required, requiredIf, maxLength, numeric } = require("vuelidate/lib/validators");

export default {
  name: "OmfCalculateTestForm",
  components: {
    ButtonFragment,
    ButtonGroup,
    CardContainer,
    TwoColumnLayout,
    FragmentSeparator,
    TextInputFragment,
    RadioGroupFragment,
    ReceiptGroupFragment,
    ReceiptItemFragment,
  },
  mixins: [validationMixin],
  props: {},
  data() {
    return {
      loading: false,
      messages: {
        required: "is verplicht",
        numeric: "is geen numerieke waarde",
        maxLength: "mag maximaal %s karakters lang zijn",
        button_reset: "Reset",
        button_submit: "Bereken",
        license_plate_label: "Kenteken",
        license_plate_placeholder: "A-123-BC",
        dealer_code_label: "Dealer code",
        dealer_code_placeholder: "",
        external_identifier_label: "Externe referentie",
        external_identifier_placeholder: "",
        vehicle_make_label: "Merk",
        vehicle_make_placeholder: "Peugeot",
        vehicle_model_label: "Model",
        vehicle_model_placeholder: "508 SW",
        vehicle_build_month_label: "Bouwmaand",
        vehicle_build_month_placeholder: "6",
        vehicle_build_year_label: "Bouwjaar",
        vehicle_build_year_placeholder: "2019",
        vehicle_mileage_label: "Kilometerstand",
        vehicle_mileage_placeholder: "16535",
        price_label: "Rijklaar prijs",
        price_placeholder: "37900",
        deposit_label: "Aanbetaling",
        deposit_placeholder: "2000",
        credit_amount_label: "Kredietbedrag",
        credit_amount_placeholder: "37900",
        final_term_amount_label: "Slottermijn",
        final_term_amount_placeholder: "2500",
        applicant_type_label: "Type aanvrager",
        applicant_type_private: "Particulier",
        applicant_type_business: "Zakelijk",
        duration_label: "Looptijd",
        duration_12_months: "12 maanden",
        duration_24_months: "24 maanden",
        duration_36_months: "36 maanden",
        duration_48_months: "48 maanden",
        duration_60_months: "60 maanden",
        duration_72_months: "72 maanden",
        vat_deductible_label: "BTW verrekenbaar",
        vat_included_label: "Verkoopprijs inclusief BTW",
        yes: "Ja",
        no: "Nee",
        empty: "Geen waarde",
        results_title: "Resultaat",
        monthly_amount_label: "Maand bedrag",
        total_credit_cost_label: "Kosten krediet",
        months_duration_in_months_sequence_label: "Looptijden",
        credit_amount_lowerboundary_label: "Min kredietbedrag",
        deposit_upper_boundary_label: "Max aanbetaling",
        final_term_amount_upperboundary_label: "Max slottermijn",
        interest_effective_label: "Effectieve rente",
        finance_company_name_label: "Maatschappij",
        finance_product_name_label: "Product",
        vehicle_type_label: "Type voertuig",
        vehicle_type_car: "Personenwagen (HK)",
        vehicle_type_van: "Bestelwagen (FL)",
        remaining_bpm_label: "BPM Bedrag",
        vat_amount_label: "BTW Bedrag",
      },
      licensePlateFieldDisabled: false,
      form: {
        error: false,
        errors: null,
        data: {
          dealerCode: null,
          externalIdentifier: null,
          licensePlate: null,
          make: null,
          model: null,
          buildMonth: null,
          buildYear: null,
          vehicleType: null,
          mileage: null,
          applicantType: "HIRE_PURCHASE",
          price: null,
          deposit: null,
          creditAmount: null,
          finalTermAmount: null,
          durationInMonths: null,
          vatDeductible: "empty",
          vatIncluded: "empty",
        },
      },
      showCalculationResult: false,
      calculationResult: {},
    };
  },
  watch: {
    data: function(newVal) {
      this.form.data = newVal;
    },
    showCalculationResult: function(newVal) {
      // scroll to top of form
      if (newVal === true) {
        window.document.getElementById("result-panel").scrollIntoView(true);
        window.scrollBy(0, -10);
      }
    },
  },
  validations() {
    // default validation wrapped in the data object.
    let data = {
      dealerCode: {
        required,
      },
      licensePlate: {
        maxLength: maxLength(8),
      },
      make: {
        required: requiredIf(function(data) {
          return data.licensePlate === null;
        }),
      },
      model: {
        required: requiredIf(function(data) {
          return data.licensePlate === null;
        }),
      },
      buildMonth: {
        required: requiredIf(function(data) {
          return data.licensePlate === null;
        }), numeric,
      },
      buildYear: {
        required: requiredIf(function(data) {
          return data.licensePlate === null;
        }), numeric,
      },
      vehicleType: {
        required: requiredIf(function(data) {
          return data.licensePlate === null;
        }),
      },
      mileage: {
        required, numeric,
      },
      applicantType: {
        required,
      },
      price: {
        required, numeric,
      },
      creditAmount: {
        required, numeric,
      },
      finalTermAmount: {
        numeric,
      },
    };
    return {
      form: {
        data,
      },
    };
  },
  computed: {
    radioGroupVehicleTypeOptions() {
      return {
        CAR: this.messages["vehicle_type_car"],
        VAN: this.messages["vehicle_type_van"],
      };
    },
    radioGroupApplicantTypeOptions() {
      return {
        HIRE_PURCHASE: this.messages["applicant_type_private"],
        FINANCIAL_LEASE: this.messages["applicant_type_business"],
      };
    },
    radioGroupDurationTypeOptions() {
      return {
        "12": this.messages["duration_12_months"],
        "24": this.messages["duration_24_months"],
        "36": this.messages["duration_36_months"],
        "48": this.messages["duration_48_months"],
        "60": this.messages["duration_60_months"],
        "72": this.messages["duration_72_months"],
      };
    },
    availableDurations() {
      if (this.calculationResult) {
        return this.calculationResult.durationSequence.join(" - ");
      }
      return "";
    },
    radioGroupOptionalBooleanOptions() {
      return {
        "empty": this.messages["empty"],
        "true": this.messages["yes"],
        "false": this.messages["no"],
      };
    },
  },
  created() {
    this.form.data.vehicleType = "CAR";
    this.form.data.applicantType = "HIRE_PURCHASE";
    this.calculationResult = {};
  },
  methods: {
    formatAmount(value) {
      if (typeof value !== "number") {
        return value;
      }
      return new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(value);
    },
    formatPercentage(value) {
      if (typeof value !== "number") {
        return value;
      }
      return new Intl.NumberFormat("nl-NL", {
        style: "percent",
        maximumSignificantDigits: 4,
      }).format(value / 100);
    },
    isFieldInvalid(field) {
      return !field && field.$dirty && field.$invalid;
    },
    optionalBoolean(value) {
      switch (value) {
        case "true":
          return true;
        case "false":
          return false;
        default:
          return undefined;
      }
    },
    reset() {
      // reset form validation errors
      this.$v.$reset();

      // reset form data
      const initialData = this.$options.data.call(this);
      Object.assign(this.$data, initialData);
    },
    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("Form is invalid");
        return;
      }

      let requestDto = {
        licensePlate: this.form.data.licensePlate,
        externalIdentifier: this.form.data.externalIdentifier,
        mileage: this.form.data.mileage,
        financingType: this.form.data.applicantType,
        price: this.form.data.price,
        deposit: this.form.data.deposit,
        creditAmount: this.form.data.creditAmount,
        finalTermAmount: this.form.data.finalTermAmount,
        durationInMonths: this.form.data.durationInMonths,
        vatDeductible: this.optionalBoolean(this.form.data.vatDeductible),
        vatIncluded: this.optionalBoolean(this.form.data.vatIncluded),
      };

      if (!requestDto.licensePlate) {
        requestDto.vehicleData = {
          make: this.form.data.make,
          model: this.form.data.model,
          buildMonth: this.form.data.buildMonth,
          buildYear: this.form.data.buildYear,
          vehicleType: this.form.data.vehicleType,
        };
      }

      console.log("Send request:", requestDto);

      // reset
      this.showCalculationResult = false;
      this.form.error = false;
      this.form.errors = null;
      this.loading = true;
      calculate(this.form.data.dealerCode, requestDto)
        .then(result => {
          console.log("Response:", result);
          this.showCalculationResult = true;
          this.calculationResult = result.data;
        })
        .catch((error) => {
          console.log("Response:", error.response);
          this.form.error = true;
          this.form.errors = error.response.data.errors;
        })
        .finally(() => this.loading = false);
    },
  },
};
</script>
<style module lang="scss">
.error {
  margin-top: 20px;
  color: red;
}

.spinnerWrapper {
  position: relative;
}

.spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 32px;
  height: 32px;
  margin-top: -16px;
  margin-left: -16px;
  border-radius: 50%;
  border: 3px solid #35ab7d;
  border-top-color: #00879c;
  border-right-color: #1f396d;
  border-bottom-color: #00879c;
  animation: spinner 0.6s linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
</style>